import React, { useEffect, createElement } from 'react';
import { SITE_IMAGES } from '../components/siteImages';
import { FamilyHeroInfo } from './family-classes/FamilyHeroInfo';
import { FamilyLeadForm } from './family-classes/FamilyLeadForm';
import { FamilyTrainTogether } from './family-classes/FamilyTrainTogether';
import { FamilyWhyParents } from './family-classes/FamilyWhyParents';
import { FamilyKidsBenefits } from './family-classes/FamilyKidsBenefits';
import { FamilyAdultBenefits } from './family-classes/FamilyAdultBenefits';
import { FamilyClassTimes } from './family-classes/FamilyClassTimes';
import { FamilyReviews } from './family-classes/FamilyReviews';
import { FamilyServiceAreas } from './family-classes/FamilyServiceAreas';
import { FamilyFAQHeader } from './family-classes/FamilyFAQHeader';
import { FamilyFAQQuestions } from './family-classes/FamilyFAQQuestions';
import { FamilyRelatedLinks } from './family-classes/FamilyRelatedLinks';
import { FamilyFinalCTA } from './family-classes/FamilyFinalCTA';
export function FamilyClasses() {
  useEffect(() => {
    document.title = 'Family Martial Arts & Family Taekwondo Classes in Farmington Hills | Storm Taekwondo';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Storm Taekwondo family classes give parents and kids a positive way to train together in Farmington Hills. Beginner-friendly, supportive coaching, all ages welcome.';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-1178">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-1179">
        <div className="absolute inset-0 opacity-25" data-id="element-1180">
          <img src={SITE_IMAGES.familyClasses} alt="Family training together at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-1181" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-1182" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1183">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1184">
            <FamilyHeroInfo data-id="element-1185" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-1186">
              <FamilyLeadForm data-id="element-1187" />
            </div>
          </div>
        </div>
      </section>
      <FamilyTrainTogether data-id="element-1188" />
      <FamilyWhyParents data-id="element-1189" />
      <FamilyKidsBenefits data-id="element-1190" />
      <FamilyAdultBenefits data-id="element-1191" />
      <FamilyClassTimes data-id="element-1192" />
      <FamilyReviews data-id="element-1193" />
      <FamilyServiceAreas data-id="element-1194" />
      <section className="py-24 bg-off-white" data-id="element-1195">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1196">
          <FamilyFAQHeader data-id="element-1197" />
          <FamilyFAQQuestions data-id="element-1198" />
        </div>
      </section>
      <FamilyRelatedLinks data-id="element-1199" />
      <FamilyFinalCTA data-id="element-1200" />
    </div>;
}